import { Fragment, ReactElement } from 'react';
import styled from 'styled-components';
import { Flex, Box } from 'reflexbox';

import { PageTitleSub } from 'packages/kakapo-ui-kit/components/common/Headings';
import FieldErrorMessage from 'packages/kakapo-ui-kit/components/forms/errors/FieldErrorMessage';
import DetailsTableFormValue, {
	DetailsTableFormValueTypes,
	IOptions,
} from 'packages/kakapo-ui-kit/components/common/DetailsTableForm/DetailsTableFormValue';
import { useTranslation } from 'react-i18next';

const TableRow = styled(Flex)`
	min-height: 48px;

	> div:not(:first-child) {
		flex: 1;
	}

	*:focus {
		outline: none;
	}
`;

const TableLabel = styled.div`
	width: 152px;
`;

const TableData = styled.div`
	min-width: 152px;
`;

export interface IProps {
	formValues: {
		label: string;
		name: string;
		initialValue?: string | number | boolean | Date | null;
		initialOption?: IOptions;
		options?: IOptions[];
		type: DetailsTableFormValueTypes;
		onClick?: () => void;
	}[];
	onEditingForm?: (isEditingForm: boolean) => void;
}

export default function DetailsTableForm({
	formValues,
	onEditingForm = () => {},
}: IProps): ReactElement {
	const { t } = useTranslation();

	return (
		<Box>
			{formValues.map((item) => (
				<Fragment key={item.name}>
					<TableRow alignItems="center">
						<TableLabel>
							<PageTitleSub>{item.label}</PageTitleSub>
						</TableLabel>

						<TableData>
							<DetailsTableFormValue
								{...item}
								onEditingForm={(isEditingForm) => onEditingForm(isEditingForm)}
							/>
						</TableData>
					</TableRow>
					<Box mb={2}>
						<FieldErrorMessage
							name={item.name}
							validationMessage={
								item.type === DetailsTableFormValueTypes.Multilingual
									? t('errors.validation.emptyMultilingualError')
									: undefined
							}
						/>
					</Box>
				</Fragment>
			))}
		</Box>
	);
}
